import * as types from './constants';
import {getAxiosInstance} from '../utils/vuex'
import useApplicationStore from "./application_module";
import actions from './application/actions'
import router from '../router';
export default {
    // [types.GET_ACCOUNT_SUMMARY](postData) {
    //     this.commit(types.TOGGLE_LOADING, true);
    //     let summary_url  = `/application/ajaxgetaccountsummary`;
    //
    //     getAxiosInstance.post(summary_url, postData)
    //         .then(res => {
    //             if (res['data']['result'] === 'SUCCESS') {
    //                 this.commit(types.SET_ACCOUNT_SUMMARY_ON_ACCOUNT_PARENT, res['data']);
    //                 this.commit(types.SET_TRADE_OUTLET_ON_ACCOUNT_PARENT, res['data']);
    //                 this.commit(types.SET_SETTLEMENT_VALUES_ON_ACCOUNT_PARENT, res['data']);
    //                 if (postData.hasOwnProperty('set_types') && postData.set_types === true) {
    //                     this.commit(types.SET_ACCOUNT_TYPES_ON_ACCOUNT_PARENT, res['data']);
    //                 }
    //                 this.commit(types.TOGGLE_LOADING, false);
    //             }
    //         });
    // },
    // [types.REASSIGN](payload) {
    //     let action = 'reassign';
    //     let reviewer_details = {key: 'sales_owner_user_external_id', value: payload.sales_owner_user_external_id};
    //     if(payload.reassign_type === types.REASSIGN_TYPE_CREATOR) {
    //         action = 'reassign';
    //         reviewer_details = {key: 'creator_user_external_id', value: payload.creator_user_external_id};
    //     }
    //     if(payload.reassign_type === types.REASSIGN_TYPE_QUALITY_REVIEWER) {
    //         action = 'assignreviewer';
    //         reviewer_details = {key: 'data_quality_reviewer_external_id', value: payload.data_quality_reviewer_external_id};
    //     }
    //     if(payload.reassign_type === types.REASSIGN_TYPE_AML) {
    //         action = 'assignamluser';
    //         reviewer_details = {key: 'aml_owner_user_external_id', value: payload.aml_owner_user_external_id};
    //     }
    //
    //     this.commit(types.TOGGLE_LOADING, true);
    //     ////console.log(payload);
    //     let url  = `/application/${action}/${this.merchant.application_reference}/`;
    //
    //     getAxiosInstance.post(url, payload)
    //         .then(res => {
    //             //console.log(res['data']);
    //             if (res['data']['result'] === 'SUCCESS') {
    //                 this.commit(types.TOGGLE_LOADING, false);
    //
    //                 this.merchant.application_status_external_id = res['data']['application']['application_status_external_id'];
    //                 this.merchant[reviewer_details.key] = reviewer_details.value;
    //
    //                 clearSnapshotForms(payload.form_name);
    //
    //                 // only redirect if owner is reassigned
    //                 if (payload.reassign_type === types.REASSIGN_TYPE_OWNER && getters.applicationStatusKey === types.APP_STATUS_OPEN) {
    //                     const action = (this.logged_in_user_id === this.merchant.sales_owner_user_external_id) ? 'edit' : 'view';
    //                     location.href = '/application/' + action + '/' + this.merchant.application_reference;
    //                 }
    //                 else if (payload.reassign_type === types.REASSIGN_TYPE_AML) {
    //                     //console.log('REASSIGN_TYPE_AML ', payload.reassign_type);
    //                     location.href = '/application/view/' + this.merchant.application_reference + '/info/snapshot';
    //                     objCommon.showCustomSuccessMessage(payload.success);
    //                 }
    //                 else {
    //                     objCommon.showCustomSuccessMessage(payload.success);
    //                 }
    //             }
    //         });
    // },
    // [types.AML_OPERATIONS](payload) {
    //     let action = 'amlapprove';
    //     if(payload.action_type === types.AML_DECLINED) {
    //         action = 'amldecline';
    //     }
    //     if(payload.action_type === types.AML_MORE_INFO_REQUIRED) {
    //         action = 'amlmoreinfo';
    //     }
    //
    //     this.commit(types.TOGGLE_LOADING, true);
    //     ////console.log(payload);
    //     let url  = `/application/${action}/${this.merchant.application_reference}/`;
    //
    //     getAxiosInstance.post(url, payload)
    //         .then(res => {
    //             //console.log(res['data']);
    //             if (res['data']['result'] === 'SUCCESS') {
    //                 objCommon.showCustomSuccessMessage(payload.success);
    //                 clearSnapshotForms(payload.form_name);
    //                 this.commit(types.TOGGLE_LOADING, false);
    //                 this.merchant.application_status_external_id = res['data']['application']['application_status_external_id'];
    //             }
    //         });
    // },
    // [types.RISK_OPERATIONS](payload) {
    //     let action = 'underwritingapproved';
    //     if(payload.action_type === types.RISK_DECLINED) {
    //         action = 'underwritingdeclined';
    //     }
    //     if(payload.action_type === types.RISK_MORE_INFO_REQUIRED) {
    //         action = 'underwritingmoreinfo';
    //     }
    //
    //     this.commit(types.TOGGLE_LOADING, true);
    //     ////console.log(payload);
    //     let url  = `/application/${action}/${this.merchant.application_reference}/`;
    //
    //     getAxiosInstance.post(url, payload)
    //         .then(res => {
    //             //console.log(res['data']);
    //             if (res['data']['result'] === 'SUCCESS') {
    //                 objCommon.showCustomSuccessMessage(payload.success);
    //                 clearSnapshotForms(payload.form_name);
    //                 this.commit(types.TOGGLE_LOADING, false);
    //                 this.merchant.application_status_external_id = res['data']['application']['application_status_external_id'];
    //             }
    //         });
    // },
    // [types.QUALITY_CHECK](payload) {
    //     this.commit(types.TOGGLE_LOADING, true);
    //     ////console.log(payload);
    //     let url  = `/application/datareview/${this.merchant.application_reference}/`;
    //
    //     getAxiosInstance.post(url, payload)
    //         .then(res => {
    //             //console.log(res['data']);
    //             if (res['data']['result'] === 'SUCCESS') {
    //                 objCommon.showCustomSuccessMessage(payload.success);
    //                 this.commit(types.SET_APPLICATION_STATUSES, res['data']);
    //                 clearSnapshotForms(payload.form_name);
    //                 this.commit(types.TOGGLE_LOADING, false);
    //             }
    //         });
    // },
    [types.SAVE_MERCHANT](payload) {
        this.commit(types.TOGGLE_LOADING, true);
        // //console.log("Payload.data: ", payload.data);
        let url  = `/application/ajaxsavemerchant/${state.merchant.application_reference}/${payload.section}`;

        getAxiosInstance.post(url, payload.data)
            .then(res => {
                if (res['data']['result'] === 'SUCCESS') {
                    objCommon.showCustomSuccessMessage(payload.success);
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.UPDATE_SUB_GROUP](payload) {
        let update_url;
        this.commit(types.TOGGLE_LOADING, true);

        // e.g merchant/manage/3000069/edit/ajaxupdateoutlet/5d83a20c806ded3576527982/outlet-information
        update_url = `/application/ajaxupdatesubgroup/${this.merchant.application_reference}/${payload.entity_id}/${payload.section}`
        let postData = payload.data;

        getAxiosInstance.post(update_url, postData)
            .then(res => {
                // no need to update state. we have state :-)
                if (res['data']['result'] === 'SUCCESS') {
                    objCommon.showCustomSuccessMessage(payload.success);
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.ADD_SUB_GROUP](payload) {
        let add_url;
        this.commit(types.TOGGLE_LOADING, true);

        add_url = `/application/ajaxaddsubgroup/${this.merchant.application_reference}/${payload.parent_mid}`;
        let postData = payload.data;

        getAxiosInstance.post(add_url, postData)
            .then(res => {
                // no need to update state. we have state :-)
                if (res['data']['result'] === 'SUCCESS') {
                    let redirect_url = `/application/edit/${this.merchant.application_reference}/hierarchy/subgroup/${res['data']['merchant_sub_group']['merchant_node_external_id']}/group-information`;
                    window.location.href = redirect_url;
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.ADD_OUTLET](payload) {
        let add_url;
        this.commit(types.TOGGLE_LOADING, true);

        add_url = `/application/ajaxaddoutlet/${this.merchant.application_reference}/${payload.parent_mid}`;
        let postData = payload.data;

        getAxiosInstance.post(add_url, postData)
            .then(res => {
                // no need to update state. we have state :-)
                if (res['data']['result'] === 'SUCCESS') {
                    let redirect_url = `/application/edit/${this.merchant.application_reference}/hierarchy/outlet/${res['data']['outlet']['merchant_node_external_id']}/outlet-information`;
                    window.location.href = redirect_url;
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.SAVE_AML_EDIT](payload) {
        let update_url;
        this.commit(types.TOGGLE_LOADING, true);

        update_url = `/application/amledit/${this.merchant.application_reference}/AML_EDIT`;
        let postData = payload.data;

        getAxiosInstance.post(update_url, postData)
            .then(res => {
                // no need to update state. we have state :-)
                if (res['data']['result'] === 'SUCCESS') {
                    objCommon.showCustomSuccessMessage(payload.success);
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.GET_REPORT](payload) {
        let add_url;
        this.commit(types.TOGGLE_LOADING, true);

        add_url = `/application/ajaxgetreport/${this.merchant.application_reference}`;
        let postData = payload.data;
        const section = payload.data.section;

        getAxiosInstance.post(add_url, postData)
            .then(res => {
                // no need to update state. we have state :-)
                if (res['data']['result'] === 'SUCCESS') {
                    if(section === types.REPORT_TYPE_AML) {
                        this.aml_report = res['data']['response'];
                    } else if(section ===  types.REPORT_TYPE_RISK) {
                        this.risk_report = res['data']['response'];
                        //console.log(state.risk_report);
                    }
                }
            });
    },
    [types.SUBMIT_MERCHANTS](payload) {
        this.commit(types.TOGGLE_LOADING, true);
        let submit_url  = `/application/ajaxsubmitapplication/`;

        getAxiosInstance.post(submit_url, {application_ref: this.merchant.application_reference})
            .then(res => {
                if (res['data']['result'] === 'SUCCESS') {
                    if(!!res['data']['errors']) {
                        this.validation_errors = res['data']['errors'];
                        this.redirect_to_error_tab = true;
                    } else {
                        objCommon.showCustomSuccessMessage(payload.success);
                        useApplicationStore()[types.SET_APPLICATION_STATUSES](res['data']);
                    }
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.UNLOCK_APPLICATION](payload) {
        this.commit(types.TOGGLE_LOADING, true);
        let unlock_url  = `/application/unlock/${this.merchant.application_external_id}`;

        getAxiosInstance.post(unlock_url, {application_ref: this.merchant.application_reference})
            .then(res => {
                if (res['data']['result'] === 'SUCCESS') {
                    objCommon.showCustomSuccessMessage(payload.success);
                    useApplicationStore()[types.SET_APPLICATION_STATUSES](res['data']);
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.EDIT_OUTLET](payload) {
        let update_url;
        this.commit(types.TOGGLE_LOADING, true);

        // e.g merchant/manage/3000069/edit/ajaxupdateoutlet/5d83a20c806ded3576527982/outlet-information
        update_url = `/application/ajaxupdateoutlet/${this.merchant.application_reference}/${payload.entity_id}/${payload.section}`
        let postData = payload.data;

        getAxiosInstance.post(update_url, postData)
            .then(res => {
                // no need to update state. we have state :-)
                if (res['data']['result'] === 'SUCCESS') {
                    objCommon.showCustomSuccessMessage(payload.success);
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.EDIT_SUBGROUP](payload) {
        let update_url;
        this.commit(types.TOGGLE_LOADING, true);

        // //console.log('state ', state);
        // e.g merchant/manage/3000069/edit/ajaxupdateoutlet/5d83a20c806ded3576527982/outlet-information
        update_url = `/application/ajaxupdatesubgroup/${this.merchant.application_reference}/${payload.entity_id}/${payload.section}`;
        let postData = payload.data;

        // //console.log('update_url ', update_url);
        // //console.log('postData ', postData);
        getAxiosInstance.post(update_url, postData)
            .then(res => {
                // no need to update state. we have state :-)
                if (res['data']['result'] === 'SUCCESS') {
                    // //console.log('res data ', res['data']);
                    objCommon.showCustomSuccessMessage(payload.success);
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.DELETE_SUBGROUP](payload) {
        this.commit(types.TOGGLE_LOADING, true);

        // //console.log('state ', state);
        let delete_url = `/application/ajaxdeletesubgroup/${this.merchant.application_reference}/${payload.entity_id}`;
        // //console.log('delete_url ', delete_url);

        this.commit('SHOW_ERROR_ALERT', '');

        let postData = payload;
        getAxiosInstance.post(delete_url, postData)
            .then(res => {
                if (res['data']['result'] === 'SUCCESS') {
                    let redirect_url = `/application/edit/${this.merchant.application_reference}`;
                    // objCommon.showCustomSuccessMessage(payload.success);
                    window.location.href = redirect_url;
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    [types.RELEASE_RESERVE](payload) {
        let update_url;
        this.commit(types.TOGGLE_LOADING, true);

        // e.g merchant/manage/3000069/edit/ajaxupdateoutlet/5d83a20c806ded3576527982/outlet-information
        update_url = `/application/ajaxreleasereserve/${this.current_account_parent.internal_mid}/13/${state.route.params.currency}`;
        let postData = payload.data;

        getAxiosInstance.post(update_url, postData)
            .then(res => {
                // no need to update state. we have state :-)
                if (res['data']['result'] === 'SUCCESS') {
                    objCommon.showCustomSuccessMessage(payload.success);
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    // [types.DELETE_OUTLET](postData) {
    //     this.commit(types.TOGGLE_LOADING, true);
    //
    //     // e.g /maintenance/ajaxdeleteoutlet/5cadd1ee806ded43197845ae/5cadd1ee806ded43197845ae
    //     let delete_url = `/application/ajaxdeleteoutlet/${this.merchant.application_reference}/${postData.outlet_id}`;
    //         //router.options.base.replace('addoutlet', 'ajaxdeleteoutlet') + '/' + state.merchant.application_reference + '/' + postData.outlet_id;
    //     // //console.log('delete_url ', delete_url);
    //     // //console.log('postData ',  postData);
    //     this.commit('SHOW_ERROR_ALERT', '');
    //     getAxiosInstance.post(delete_url, postData)
    //         .then(res => {
    //             if (res['data']['result'] === 'SUCCESS') {
    //                 let redirect_url = `/application/edit/${this.merchant.application_reference}`;
    //                 // //console.log('redirect_url ', redirect_url);
    //                 // objCommon.showCustomSuccessMessage(postData.success);
    //                 window.location.href = redirect_url;
    //                 //window.location.href = router.options.base;
    //                 // commit(types.REMOVE_OUTLET, {outlet_ref: outlet_ref});
    //                 this.commit(types.TOGGLE_LOADING, false);
    //             }
    //
    //         });
    // },
    // [types.GET_OUTLET_SUMMARY](postData) {
    //     this.commit(types.TOGGLE_LOADING, true);
    //     let url  = router.options.history.base.replace('viewaddoutlet', 'ajaxretrieveoutlets');
    //
    //     getAxiosInstance.post(url, postData)
    //         .then(res => {
    //             if (res['data']['result'] === 'SUCCESS') {
    //                 this.commit(types.GET_OUTLET_SUMMARY,{
    //                     outlets_service_charges_summary: res['data']['outlets'] || [],
    //                     other_service_charges_summary: res['data']['formatted_charges_others'] || []
    //                 });
    //               let summary_url = `/summary`;
    //                 this.commit(types.TOGGLE_LOADING, true);
    //                 router.push({path:summary_url});
    //             } else {
    //                 console.error(res['data']);
    //                 this.commit(types.TOGGLE_LOADING, false);
    //             }
    //         })
    //         .catch(err=>{
    //             console.error(err);
    //         });
    // },
    [types.GET_MERCHANT_VALIDATION_ERRORS](postData) {
        let url = '/application/ajaxgetvalidationerrors/' + state.merchant.application_reference;

        if(Object.entries(state.validation_errors).length === 0) {
            this.commit(types.TOGGLE_LOADING, true);
            getAxiosInstance.post(url, postData)
                .then(res => {
                    if (res['data']['result'] === 'SUCCESS') {
                        this.commit(types.GET_MERCHANT_VALIDATION_ERRORS, res['data']['validation_errors']);
                        this.commit(types.TOGGLE_LOADING, false);
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        }
    },
    [types.GET_HIERARCHY_DAILY_INFO](postData) {
        this.commit(types.TOGGLE_LOADING, true);
        // //console.log('hehrh')
        let url  = `/application/ajaxgetdailyinfo`;

        getAxiosInstance.post(url, postData)
            .then(res => {
                if (res['data']['result'] === 'SUCCESS') {
                   //console.log(res)
                    this.commit(types.TOGGLE_LOADING, false);
                }
            });
    },
    //former mutations
    [types.SET_ALLIANCE_DATA](payload){ this.alliance = payload },
    [types.SET_SUPPORT_PHONE](payload){ this.support_phone = payload },
    [types.SET_LOGGED_IN_USER](payload){ this.user = payload },
    [types.SET_MY_LANGUAGE](payload) { this.my_language = payload },
    [types.SET_BRANDING](payload) { this.branding = payload },
    [types.SHOW_ERROR_ALERT](payload) { this.error_message = payload },
    // [types.SET_QUOTE_DATA]: set('quote'),
    [types.SET_PARAMETERS]: function (payload){
        this.parameters = {...this.parameters, ...payload};
    },
    [types.SET_USER_PERMISSIONS](payload) { this.user_permissions = payload },
    [types.SET_WORKFLOW_PERMISSIONS](payload){ this.workflow_permissions = payload },
    [types.SET_MERCHANT_USER_ACCESS](payload) { this.merchant_user_access = payload },
    [types.SET_DASHBOARD_DATA](payload) { this.dashboard = payload },
    [types.SET_GLOBAL_ERRORS]: function (payload) {
        this.global_errors.push(payload)
    },
    [types.TOGGLE_LOADING](payload) { this.is_loading = payload },

    commit(action, payload) {
        if (action === 'SHOW_ERROR_ALERT') {
            this.error_message = payload
        } else if (action === types.TOGGLE_LOADING) {
            this.is_loading = payload
        }else {
            this[action](payload)
        }
    },

}
